<template>
  <div class="card has-width-500 has-padding-30">
    <div>
      <h4 class="has-padding-10 is-size-4">
        Delete User -
        <span class="is-size-4 has-text-weight-bold">{{user_details.name}}</span>
      </h4>
    </div>
    <div>
      <form action @submit.prevent="deleteUser">
        <div class="modal-card" style="width: auto">
          <section class="modal-card-body">
            <div>Please confirm that you want to delete this user.</div>
            <b-checkbox class="has-margin-top-20" required>Yes Delete User</b-checkbox>
          </section>
          <footer class="modal-card-foot">
            <button class="button" type="button" @click="$parent.close()">Close</button>
            <button class="button is-primary" loading>Delete</button>
          </footer>
        </div>
      </form>
    </div>
  </div>
</template>


<script>
import InputWithValidation from "@/modules/commonModule/components/formInputs/inputWithValidation";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import Multiselect from "vue-multiselect";
import { createNamespacedHelpers } from "vuex";
const { mapGetters, mapMutations } = createNamespacedHelpers("admin");
import DeleteUserMutation from "../api/graphql/mutations/DeleteUserMutation";
import { async } from "q";
import { mapGetters as mapRootGetters } from "vuex";

export default {
  name: "admin-delete-user",
  components: {
    InputWithValidation,
    ValidationObserver,
    Multiselect
  },
  props: {
    user_details: { type: Object, required: true }
  },
  data() {
    return {
      current_user: null,
      loading: false
    };
  },

  mounted() {
    /**
     * Get the right user
     */
    if (this.isNimasaAdmin) {
      this.current_user = "nimasaAdmin";
    }

    if (this.isHudsontridentUser) {
      this.current_user = "hudsontridentAdmin";
    }
  },
  computed: {
    ...mapGetters({
      isNimasaAdmin: "isNimasaAdmin",
      isHudsontridentUser: "isHudsontridentUser"
    }),
    deleteUser() {
      if (this.user_details.role === "Port User") {
        return this.deletePortUser;
      }
      if (this.user_details.role === "NIMASA Admin User") {
        return this.deleteNimasaAdminUser;
      }
      if (this.user_details.role === "NIMASA Agent" || "NIMASA Manager") {
        return this.deleteNimasaUser;
      }
    }
  },
  methods: {
    /**
     * Create Port User
     */
    deletePortUser: async function() {
      this.loading = true;

      this.$apollo
        .mutate({
          mutation: DeleteUserMutation.PortUserMutation,
          variables: {
            id: this.user_details.id
          }
        })
        .then(response => {
          const port_user_name = response.data.DeletePortUser.name;
          this.$toast.open({
            duration: 6000,
            message: `The Port User details have been deleted successfully`,
            type: "is-success"
          });
          this.$parent.close();
          setTimeout(() => this.$router.go({ name: "all-users" }), 3000);
        })
        .catch(err => {
          this.$toast.open({
            duration: 5000,
            message: "Could not delete user at the moment, try again later",
            type: "is-danger"
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },

    /**
     * Create NIMASA Admin User
     */
    deleteNimasaAdminUser: async function() {
      this.loading = true;

      this.$apollo
        .mutate({
          mutation: DeleteUserMutation.NimasaAdminUserMutation,
          variables: {
            id: this.user_details.id
          }
        })
        .then(response => {
          const admin_user_name = response.data.DeleteNimasaAdminUser.name;
          this.$toast.open({
            duration: 8000,
            message: `${admin_user_name.toUpperCase()} has been deleted successfully.`,
            type: "is-success"
          });
          this.$parent.close();
          setTimeout(() => this.$router.go({ name: "all-users" }), 3000);
        })
        .catch(err => {
          this.$toast.open({
            duration: 5000,
            message: "Could not delete user at the moment, try again later",
            type: "is-danger"
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    /**
     * Create NIMASA User.
     */

    deleteNimasaUser: async function() {
      this.loading = true;

      this.$apollo
        .mutate({
          mutation: DeleteUserMutation.NimasaUserMutation,
          variables: {
            id: this.user_details.id
          }
        })
        .then(response => {
          const nimasa_user_name = response.data.DeleteNimasaUser.name;
          this.$toast.open({
            duration: 8000,
            message: `User ${nimasa_user_name.toUpperCase()} has been deleted successfully.`,
            type: "is-success"
          });
          this.$parent.close();
          setTimeout(() => this.$router.go({ name: "all-users" }), 3000);
        })
        .catch(err => {
          this.$toast.open({
            duration: 5000,
            message: "Could not delete user at the moment, try again later",
            type: "is-danger"
          });
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>